import type { ShopState } from './state'

export default {
  shopFilterEntityIds (state: ShopState) {
    return state.filterEntityIds || []
  },
  shopConfig (state: ShopState) {
    return state.shopConfig
  },
  overviewFilterTypes (state: ShopState) {
    return state.shopConfig.overviewFilterTypes
  },
  salesChannelIds (state: ShopState) {
    return state.shopConfig.salesChannelIds
  },
  paymentMethods (state: ShopState) {
    return state.shopConfig.paymentMethods || []
  },
  type (state: ShopState) {
    return state.shopConfig.type
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/shop/getters.js